import {ApiService} from "../index";
import {APIConfig} from "../../../constants";
import {IClientDetailsSteps, IClientFormSteps} from "../../models/client.model";
import RouteConfigService from "../route-config.service";

const ClientInjuryDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.CLIENT_INJURY_DETAILS_SAVE.METHOD](APIConfig.CLIENT_INJURY_DETAILS_SAVE.URL, payload);
}
const ClientInjuryDetailsUpdateAPICall = (payload: any, formId: string) => {
    return ApiService[APIConfig.CLIENT_INJURY_DETAILS_UPDATE.METHOD](APIConfig.CLIENT_INJURY_DETAILS_UPDATE.URL(formId), payload);
}
const ClientBasicDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_BASIC_DETAILS.METHOD](APIConfig.SAVE_CLIENT_BASIC_DETAILS.URL, payload);
}

const GetPersonalDetailsAPICall = () => {
    return ApiService[APIConfig.GET_CLIENT_BASIC_DETAILS.METHOD](APIConfig.GET_CLIENT_BASIC_DETAILS.URL);
}

const ClientCommunicationReferralDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_COMMUNICATION_REFERRAL_DETAILS.METHOD](APIConfig.SAVE_CLIENT_COMMUNICATION_REFERRAL_DETAILS.URL, payload);
}

const GetClientCommunicationReferralDetailsAPICall = () => {
    return ApiService[APIConfig.GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS.METHOD](APIConfig.GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS.URL);
}

const GetClientMedicalHistoryDetailsAPICall = () => {
    return ApiService[APIConfig.GET_CLIENT_MEDICAL_HISTORY_DETAILS.METHOD](APIConfig.GET_CLIENT_MEDICAL_HISTORY_DETAILS.URL);
}

const ClientMedicalProviderInfoDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_PROVIDER_INFO_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_PROVIDER_INFO_DETAILS.URL, payload);
}

const ClientPhysicalActivityQuestionnaireDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.ADD_PHYSICAL_ACTIVITY_QUESTIONNAIRE.METHOD](APIConfig.ADD_PHYSICAL_ACTIVITY_QUESTIONNAIRE.URL, payload);
}

const SubmitRegistrationConsentAPICall = (payload: any) => {
    return ApiService[APIConfig.SUBMIT_REGISTRATION_CONSENT_FORM.METHOD](APIConfig.SUBMIT_REGISTRATION_CONSENT_FORM.URL, payload);
}

const RegistrationConsentUpdateAPICall = (payload: any, formId: string) => {
    return ApiService[APIConfig.UPDATE_REGISTRATION_CONSENT_FORM.METHOD](APIConfig.UPDATE_REGISTRATION_CONSENT_FORM.URL(formId), payload);
}

const ClientMedicalHistoryQuestionnairePersonalDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_PERSONAL_HABITS_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_PERSONAL_HABITS_DETAILS.URL, payload);
}

const ClientMedicalHistoryQuestionnaireMedicationSupplementsDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_MEDICATION_SUPPLEMENTS_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_MEDICATION_SUPPLEMENTS_DETAILS.URL, payload);
}

const ClientMedicalHistoryQuestionnaireAllergiesDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_ALLERGIES_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_ALLERGIES_DETAILS.URL, payload);
}

const ClientMedicalHistoryMedicalHistoryDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_MEDICAL_HISTORY_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_MEDICAL_HISTORY_DETAILS.URL, payload);
}

const ClientMedicalHistoryFemaleOnlyDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_FEMALE_ONLY_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_FEMALE_ONLY_DETAILS.URL, payload);
}

const ClientMedicalHistorySurgicalHistoryDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_SURGICAL_HISTORY_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_SURGICAL_HISTORY_DETAILS.URL, payload);
}

const ClientMedicalHistoryMusculoskeletalHistoryDetailsSaveAPICall = (payload: any) => {
    return ApiService[APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_MUSCULOSKELETAL_HISTORY_DETAILS.METHOD](APIConfig.SAVE_CLIENT_MEDICAL_HISTORY_MUSCULOSKELETAL_HISTORY_DETAILS.URL, payload);
}

const NavigateToClientDetails = (step: IClientDetailsSteps) => {
    return RouteConfigService.ProfileDetails() + "?currentStep=" + step;
}

const NavigateToPreferencesDetails = (step: IClientDetailsSteps) => {
    return RouteConfigService.ProfilePreferencesDetails() + "?currentStep=" + step;
}


const NavigateToClientEdit = (step: IClientFormSteps) => {
    return RouteConfigService.ProfileEdit() + "?currentStep=" + step;
}
const ClientCaseDetailsAPICall = (caseId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_CLIENT_CASE_DETAIL.METHOD](APIConfig.GET_CLIENT_CASE_DETAIL.URL(caseId), payload);
}
const getClientPdf = (caseId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_CLIENT_PDF.METHOD](APIConfig.GET_CLIENT_PDF.URL(caseId), payload);
}

const getClientDocument = (caseId: string, documentId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_CLIENT_DOCUMENT.METHOD](APIConfig.GET_CLIENT_DOCUMENT.URL(caseId, documentId), payload);
}
const ClientWaiverAndReleaseOfLiability = (payload: any) => {
    return ApiService[APIConfig.CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY.METHOD](APIConfig.CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY.URL, payload);
}

const RequestAccessAPICall = (payload: any) => {
    return ApiService[APIConfig.REQUEST_ACCOUNT_ACCESS.METHOD](APIConfig.REQUEST_ACCOUNT_ACCESS.URL, payload);
}

const GrantAccessAPICall = (payload: any) => {
    return ApiService[APIConfig.GRANT_ACCESS_TO_PROFILE.METHOD](APIConfig.GRANT_ACCESS_TO_PROFILE.URL, payload);
}

const FoundProfile = (payload: any) => {
    return ApiService[APIConfig.FIND_PROFILE.METHOD](APIConfig.FIND_PROFILE.URL, payload);
}
const UnlinkProfile = (clientId: string, payload: any) => {
    return ApiService[APIConfig.UNLINK_PROFILE.METHOD](APIConfig.UNLINK_PROFILE.URL(clientId), payload);
}

const editProfileLinking = (profileId: string, payload: any) => {
    return ApiService[APIConfig.EDIT_PROFILE_LINKING.METHOD](APIConfig.EDIT_PROFILE_LINKING.URL(profileId), payload);
}

const approveRejectProfileLinking = (profileId: string, type: string, payload: any) => {
    return ApiService[APIConfig.APPROVE_REJECT_PROFILE_LINKING.METHOD](APIConfig.APPROVE_REJECT_PROFILE_LINKING.URL(profileId, type), payload);
}

const updateProfileStatus = (clientId: string, payload: any) => {
    return ApiService[APIConfig.UPDATE_PROFILE_STATUS.METHOD](APIConfig.UPDATE_PROFILE_STATUS.URL(clientId), payload);
}
const cancelRequestedAccess = (selectedProfileID: string, payload: any) => {
    return ApiService[APIConfig.CANCEL_REQUESTED_ACCESS.METHOD](APIConfig.CANCEL_REQUESTED_ACCESS.URL(selectedProfileID), payload);
}
const ClientAddDetails = (payload: any) => {
    return ApiService[APIConfig.ADD_NEW_CLIENT.METHOD](APIConfig.ADD_NEW_CLIENT.URL, payload)
}

const newClientRegister = (payload: any) => {
    return ApiService[APIConfig.NEW_CLIENT_REGISTER.METHOD](APIConfig.NEW_CLIENT_REGISTER.URL, payload)
}

const ClientAuthorizationToReleaseInformation = (payload: any) => {
    return ApiService[APIConfig.CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION.METHOD](APIConfig.CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION.URL, payload)
}

const ClientAuthorizationToReleaseInformationUpdate = (payload: any, formId: string) => {
    return ApiService[APIConfig.CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION_UPDATE.METHOD](APIConfig.CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION_UPDATE.URL(formId), payload)
}

const GetClientAuthorizationDetailsAPICall = (formId: string) => {
    return ApiService[APIConfig.GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION.METHOD](APIConfig.GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION.URL(formId));
}

const GetClientFirstInjuryFormDetailsAPICall = () => {
    return ApiService[APIConfig.GET_CLIENT_FIRST_INJURY_FORM_DETAILS.METHOD](APIConfig.GET_CLIENT_FIRST_INJURY_FORM_DETAILS.URL, {});
}

const getClientFirstAuthorizationForm = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FIRST_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS.METHOD](APIConfig.GET_FIRST_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS.URL, payload)
}

const getAuthorizationDiscloseProtectedHealthInformation = (appointmentId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_AUTHORIZATION_DISCLOSE.METHOD](APIConfig.GET_AUTHORIZATION_DISCLOSE.URL(appointmentId), payload)
}

const postAuthorizationDiscloseProtectedHealthInformation = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.POST_AUTHORIZATION_DISCLOSE.METHOD](APIConfig.POST_AUTHORIZATION_DISCLOSE.URL, payload)
}


const getClientActivityLogs = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_CLIENT_ACTIVITY_LOGS.METHOD](APIConfig.GET_CLIENT_ACTIVITY_LOGS.URL, payload)
}

const getClientSignatureDetails = (isOnboarded: boolean, initialAppointmentId?: string) => {
    return ApiService[APIConfig.GET_CLIENT_SIGNATURE_DETAILS.METHOD](APIConfig.GET_CLIENT_SIGNATURE_DETAILS.URL(isOnboarded, initialAppointmentId));
}

const getWaiverAndReleaseOfLiability = (payload: any) => {
    return ApiService[APIConfig.GET_CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY.METHOD](APIConfig.GET_CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY.URL, payload);
}

const getPhysicalActivityQuestionnaire = (appointmentId: string) => {
    return ApiService[APIConfig.GET_PHYSICAL_ACTIVITY_QUESTIONNAIRE.METHOD](APIConfig.GET_PHYSICAL_ACTIVITY_QUESTIONNAIRE.URL(appointmentId));
}

const getRequestAccessDetails = (requestId: string) => {
    return ApiService[APIConfig.GET_REQUEST_ACCESS_DETAILS.METHOD](APIConfig.GET_REQUEST_ACCESS_DETAILS.URL(requestId));
}

const approveRequestAccess = (profileId: string, payload: any) => {
    return ApiService[APIConfig.APPROVE_REQUEST.METHOD](APIConfig.APPROVE_REQUEST.URL(profileId), payload);
}
const rejectRequestAccess = (profileId: string) => {
    return ApiService[APIConfig.REJECT_REQUEST.METHOD](APIConfig.REJECT_REQUEST.URL(profileId));
}

const attendanceAndPrivacyPolicy = (payload: any) => {
    return ApiService[APIConfig.ATTENDANCE_AND_PRIVACY_POLICY.METHOD](APIConfig.ATTENDANCE_AND_PRIVACY_POLICY.URL, payload);
}

const getAllServicesList = () => {
    return ApiService[APIConfig.GET_ALL_SERVICE_LIST.METHOD](APIConfig.GET_ALL_SERVICE_LIST.URL)
}
const getPendingRequestCsCount = () => {
    return ApiService[APIConfig.GET_REQUEST_COUNT.METHOD](APIConfig.GET_REQUEST_COUNT.URL)
}

const ClientService = {
    ClientInjuryDetailsSaveAPICall,
    ClientBasicDetailsSaveAPICall,
    GetPersonalDetailsAPICall,
    ClientCommunicationReferralDetailsSaveAPICall,
    GetClientCommunicationReferralDetailsAPICall,
    GetClientMedicalHistoryDetailsAPICall,
    ClientMedicalProviderInfoDetailsSaveAPICall,
    SubmitRegistrationConsentAPICall,
    ClientMedicalHistoryQuestionnairePersonalDetailsSaveAPICall,
    ClientMedicalHistoryQuestionnaireMedicationSupplementsDetailsSaveAPICall,
    ClientMedicalHistoryQuestionnaireAllergiesDetailsSaveAPICall,
    ClientMedicalHistoryMedicalHistoryDetailsSaveAPICall,
    ClientMedicalHistoryFemaleOnlyDetailsSaveAPICall,
    ClientMedicalHistorySurgicalHistoryDetailsSaveAPICall,
    ClientMedicalHistoryMusculoskeletalHistoryDetailsSaveAPICall,
    NavigateToClientDetails,
    NavigateToClientEdit,
    ClientCaseDetailsAPICall,
    ClientWaiverAndReleaseOfLiability,
    RequestAccessAPICall,
    UnlinkProfile,
    FoundProfile,
    editProfileLinking,
    approveRejectProfileLinking,
    updateProfileStatus,
    cancelRequestedAccess,
    ClientAddDetails,
    ClientAuthorizationToReleaseInformation,
    ClientInjuryDetailsUpdateAPICall,
    RegistrationConsentUpdateAPICall,
    ClientAuthorizationToReleaseInformationUpdate,
    getClientPdf,
    GetClientAuthorizationDetailsAPICall,
    GetClientFirstInjuryFormDetailsAPICall,
    getClientFirstAuthorizationForm,
    getAuthorizationDiscloseProtectedHealthInformation,
    getClientActivityLogs,
    getClientDocument,
    getClientSignatureDetails,
    getWaiverAndReleaseOfLiability,
    ClientPhysicalActivityQuestionnaireDetailsSaveAPICall,
    getPhysicalActivityQuestionnaire,
    NavigateToPreferencesDetails,
    GrantAccessAPICall,
    getRequestAccessDetails,
    approveRequestAccess,
    rejectRequestAccess,
    attendanceAndPrivacyPolicy,
    getAllServicesList,
    newClientRegister,
    getPendingRequestCsCount,
    postAuthorizationDiscloseProtectedHealthInformation
}

export default ClientService;
